import { changeRef, isUrlHttp } from '@/utils/location';
import { useContext, useEffect, useState } from 'react';
import { navigate } from 'gatsby';
import UseTraceItemShipping from '@/hooks/useTraceItemShipping';
import GlobalContext from '../../../contexts/globalContext';
import './chatButton.scss';

interface ChatButtonInterface {
    iconOpen: string;
    iconClose: string;
    data: any;
}

const ChatButton = (props: ChatButtonInterface) => {
    const { iconOpen, iconClose, data } = props;

    const [open, setOpen] = useState(false);
    const { gigyaContext, userInfoContext } = useContext(GlobalContext);

    const handleClick = (e, item) => {
        e.preventDefault();
        if (gigyaContext?.gigyaAccount) {
            UseTraceItemShipping(
                gigyaContext?.gigyaAccount?.profile.firstName +
                    ' ' +
                    (gigyaContext?.gigyaAccount?.data.secondName
                        ? gigyaContext.gigyaAccount.data.secondName + ' '
                        : '') +
                    gigyaContext?.gigyaAccount?.profile.lastName +
                    (gigyaContext?.gigyaAccount?.data.secondLastName
                        ? ' ' + gigyaContext?.gigyaAccount?.data.secondLastName
                        : ''),
                gigyaContext?.gigyaAccount?.data.docNumber,
                gigyaContext?.gigyaAccount?.data.docType,
                gigyaContext?.gigyaAccount?.profile.email,
                'click',
                `MenuCircular :: MenuCircular :: } ClickOpcion${item.nombre.replace(
                    /\s+/g,
                    ''
                )}`,
                userInfoContext.data?.userJwt
            );
        }

        if (!item?.redireccion) return;

        if (isUrlHttp(item.redireccion)) {
            window.open(item.redireccion, '_self');
            return;
        }

        navigate(changeRef(item.redireccion));
    };

    useEffect(() => {
        const webchat: any = document.getElementById('cai-webchat-div');
        if (open) {
            webchat?.setAttribute('class', '--visible');
        } else {
            webchat?.setAttribute('class', '--no-visible');
        }
    }, [open]);

    return (
        <div className="m-circularMenu">
            <div
                onClick={() => setOpen(false)}
                className={`m-circularMenu__background ${
                    open ? '--active' : ''
                }`}
            ></div>
            <div
                onClick={() => setOpen(!open)}
                className={`m-circularMenu__btn ${open ? '--opened' : ''}`}
            >
                {open ? (
                    <img
                        src={iconClose || ''}
                        alt="Cerrar Menú"
                        title="Cerrar menu"
                    />
                ) : (
                    <img src={iconOpen} alt="Abrir Menú" title="Abrir menu" />
                )}
            </div>
            <div
                className={`m-circularMenu__buttons ${open ? '--active' : ''}`}
            >
                {data.map((btn: any) => (
                    <div
                        className="m-circularMenu__buttons__btn"
                        key={btn.nombre}
                    >
                        <div className="m-circularMenu__buttons__btn__name">
                            <span>{btn.nombre}</span>
                        </div>
                        <div
                            className="m-circularMenu__buttons__btn__icon"
                            onClick={(e) => handleClick(e, btn)}
                        >
                            {btn.icono && btn.icono !== null ? (
                                <i className={`icon-${btn.icono}`}></i>
                            ) : btn.imagen ? (
                                <img
                                    src={btn.imagen && btn.imagen[0].file.url}
                                    alt={btn.nombre}
                                    title={btn.nombre}
                                />
                            ) : null}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ChatButton;
